import { apiClient, type AreaSelectListExEntity } from '@/libs/api'

export type FetchAreasQuery = {
  tenantKey: string
}

// select box 用 エリアマスタ取得api
export const fetchAreas = async (
  { tenantKey }: FetchAreasQuery,
  signal?: AbortSignal
): Promise<AreaSelectListExEntity[]> => {
  const { data } = await apiClient._tenant(tenantKey).areas.$get({
    config: {
      signal
    }
  })
  return data
}
